import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ChatWidget from '../components/ChatWidget';

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white" data-testid="privacy-policy-page">
      <Header />

      <main className="pt-28 pb-20">
        <div className="max-w-3xl mx-auto px-6">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-[#888] hover:text-[#1A1A1C] mb-8 transition-colors"
            data-testid="back-button"
          >
            <ArrowLeft className="w-5 h-5" strokeWidth={1.5} />
            Back
          </button>

          <h1 className="text-4xl sm:text-5xl font-bold text-[#1A1A1C] font-['Manrope'] tracking-tight mb-4">
            Privacy Policy
          </h1>
          <p className="text-[#888] mb-12">Last updated: April 2026</p>

          <div className="space-y-10">
            <section>
              <h2 className="text-xl font-bold text-[#1A1A1C] font-['Manrope'] mb-3">Information We Collect</h2>
              <p className="text-[#555] leading-relaxed mb-3">
                When you visit NestFlow or make a purchase, we may collect the following information:
              </p>
              <ul className="space-y-2 text-[#555]">
                <li className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#1A1A1C] mt-2 flex-shrink-0" />
                  Name and email address (when you subscribe to our newsletter or use our chat)
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#1A1A1C] mt-2 flex-shrink-0" />
                  Payment information (processed securely by Stripe — we never store card details)
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#1A1A1C] mt-2 flex-shrink-0" />
                  Browsing data and cookies for site functionality and analytics
                </li>
              </ul>
            </section>

            <hr className="border-[#F0F0F0]" />

            <section>
              <h2 className="text-xl font-bold text-[#1A1A1C] font-['Manrope'] mb-3">How We Use Your Information</h2>
              <ul className="space-y-2 text-[#555]">
                <li className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#1A1A1C] mt-2 flex-shrink-0" />
                  To process and fulfill your orders
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#1A1A1C] mt-2 flex-shrink-0" />
                  To send order confirmations and shipping updates
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#1A1A1C] mt-2 flex-shrink-0" />
                  To send newsletters and promotional emails (only if you opt in)
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#1A1A1C] mt-2 flex-shrink-0" />
                  To improve our website and customer experience
                </li>
              </ul>
            </section>

            <hr className="border-[#F0F0F0]" />

            <section>
              <h2 className="text-xl font-bold text-[#1A1A1C] font-['Manrope'] mb-3">Data Security</h2>
              <p className="text-[#555] leading-relaxed">
                We take reasonable measures to protect your personal information. All payment transactions are processed through Stripe's secure, PCI-compliant platform. We do not store your credit card information on our servers.
              </p>
            </section>

            <hr className="border-[#F0F0F0]" />

            <section>
              <h2 className="text-xl font-bold text-[#1A1A1C] font-['Manrope'] mb-3">Third-Party Services</h2>
              <p className="text-[#555] leading-relaxed">
                We use trusted third-party services to operate our store, including Stripe for payment processing. These services have their own privacy policies governing how they handle your data.
              </p>
            </section>

            <hr className="border-[#F0F0F0]" />

            <section>
              <h2 className="text-xl font-bold text-[#1A1A1C] font-['Manrope'] mb-3">Your Rights</h2>
              <p className="text-[#555] leading-relaxed mb-3">You have the right to:</p>
              <ul className="space-y-2 text-[#555]">
                <li className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#1A1A1C] mt-2 flex-shrink-0" />
                  Request access to the personal data we hold about you
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#1A1A1C] mt-2 flex-shrink-0" />
                  Request correction or deletion of your data
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#1A1A1C] mt-2 flex-shrink-0" />
                  Unsubscribe from marketing emails at any time
                </li>
              </ul>
            </section>

            <hr className="border-[#F0F0F0]" />

            <section className="bg-[#FAFAFA] rounded-xl p-8 text-center">
              <h2 className="text-xl font-bold text-[#1A1A1C] font-['Manrope'] mb-2">Questions?</h2>
              <p className="text-[#555]">
                Contact us at{' '}
                <a href="mailto:nestflowstore@gmail.com" className="text-[#1A1A1C] font-semibold hover:underline">
                  nestflowstore@gmail.com
                </a>{' '}
                for any privacy-related inquiries.
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
      <ChatWidget />
    </div>
  );
};

export default PrivacyPolicyPage;
